var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"batches-open","route":"/reports/billing-batches-open","file-name":"lotes-em-aberto.xlsx","period-label":"Período de envio do lote","columns":_vm.columns,"default-days":180}})
}
var staticRenderFns = []

export { render, staticRenderFns }